module.exports = __webpack_public_path__ + "static/img/videoBoxBg.dd45af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videoBoxBg.png
// module id = DcVC
// module chunks = 2